exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt20 {\n  margin-top: 2vh;\n}\n", ""]);

// exports
